import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { peticionGet } from "Componentes/ComponenteAxios";

const ComboApi = ({
  endpoint,
  label,
  value,
  onChange,
  keyProp = "id",
  valueProp = "id",
  labelProp = "nombre",
  disabled = false,
  fullwidth = false,
  sx = {},
  seleccionarAutoPrimeraOpcion = true,
}) => {

  const [options, setOptions] = useState([]);
  const [internalValue, setInternalValue] = useState("");
  const [cargando, setCargando] = useState(true);

  // Normalizar (localStorage devuelve strings)
  const valorNormalizado =
    typeof value === "string" ? Number(value) : value;

  useEffect(() => {
    if (!endpoint) return;

    setCargando(true);

    peticionGet(endpoint).then(({ peticion, error }) => {
      if (!error && peticion?.datos?.length > 0) {
        const datos = peticion.datos;
        setOptions(datos);

        const firstValue = datos[0][valueProp];
        const saved = localStorage.getItem("jornadaSeleccionada");

        // Autoselect SOLO si no hay valor guardado
        if (
          seleccionarAutoPrimeraOpcion &&
          !saved &&
          (value === undefined || value === null || value === "")
        ) {
          setInternalValue(firstValue);
          if (typeof onChange === "function") {
            onChange({ target: { value: firstValue } });
          }
        }
      }

      setCargando(false);
    });
  }, [endpoint]);

  // ⭐ ***** FIX DEFINITIVO ***** ⭐
  // Cuando llegan las opciones y valorNormalizado es válido,
  // forzamos a que el select lo muestre.
  useEffect(() => {
    if (
      options.length > 0 &&
      valorNormalizado !== null &&
      valorNormalizado !== undefined &&
      valorNormalizado !== ""
    ) {
      setInternalValue(valorNormalizado);
    }
  }, [options, valorNormalizado]);
  // ⭐ ******************************** ⭐

  // Determinar valor final del select
  const valorFinal =
    options.some((o) => o[valueProp] === internalValue)
      ? internalValue
      : "";

  const labelId = `${(label || "combo").toLowerCase().replace(/\s/g, "-")}-label`;

  console.log("VALOR FINAL:", valorFinal, typeof valorFinal);
  console.log("OPTIONS:", options.map(o => ({ val: o[valueProp], type: typeof o[valueProp], label: o[labelProp] })));


  return (
    <FormControl
      fullWidth={fullwidth}
      size="small"
      variant="outlined"
      disabled={disabled || cargando}
      sx={{
        "& .MuiInputBase-root": { height: 40 },
        "& .MuiInputLabel-root": { top: -6 },
        ...sx,
      }}
    >
      <InputLabel id={labelId}>{label}</InputLabel>

      <Select
        labelId={labelId}
        value={valorFinal}
        label={label}
        onChange={(e) => {
          const v = e.target.value;
          setInternalValue(v);
          if (typeof onChange === "function") onChange(e);
        }}
      >
        <MenuItem value="">
          <em>Seleccionar...</em>
        </MenuItem>

        {cargando ? (
          <MenuItem value="">
            <CircularProgress size={20} />
          </MenuItem>
        ) : (
          options.map((o) => (
            <MenuItem key={o[keyProp]} value={o[valueProp]}>
              {o[labelProp]}
            </MenuItem>
          ))
        )}
      </Select>

    </FormControl>
  );
};

export default ComboApi;
